/* CV funnel scripts */
(function () {
  'use strict';
  var locale = document.documentElement.lang || 'fr';

  /* Dates: <span data-cv-date="0" data-cv-format="long"></span> -> today (+offset days) */
  document.querySelectorAll('[data-cv-date]').forEach(function (el) {
    var d = new Date();
    d.setDate(d.getDate() + parseInt(el.getAttribute('data-cv-date') || '0', 10));
    var fmt = el.getAttribute('data-cv-format') === 'short'
      ? { day: 'numeric', month: 'long' }
      : { day: 'numeric', month: 'long', year: 'numeric' };
    try { el.textContent = d.toLocaleDateString(locale, fmt); } catch (e) { el.textContent = d.toDateString(); }
  });

  /* Countdown to local midnight */
  document.querySelectorAll('[data-cv-countdown]').forEach(function (el) {
    function tick() {
      var now = new Date();
      var end = new Date(now); end.setHours(23, 59, 59, 999);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var h = String(Math.floor(s / 3600)).padStart(2, '0');
      var m = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      var sec = String(s % 60).padStart(2, '0');
      el.textContent = h + ':' + m + ':' + sec;
    }
    tick(); setInterval(tick, 1000);
  });

  /* Rotating announcement bar */
  document.querySelectorAll('[data-cv-rotator]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.cv-rotating-bar__msg');
    if (!msgs.length) return;
    var i = 0;
    function show(n) { msgs[i].classList.remove('is-active'); i = (n + msgs.length) % msgs.length; msgs[i].classList.add('is-active'); }
    var prev = bar.querySelector('[data-prev]'), next = bar.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    setInterval(function () { show(i + 1); }, 4000);
  });

  /* Simple slider (gallery + testimonials) */
  document.querySelectorAll('[data-cv-slider]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (!slides.length) return;
    var i = 0;
    /* Hidden lazy slides never load until shown, so fetch them early without competing with the first paint */
    function warm(n) {
      var img = slides[(n + slides.length) % slides.length].querySelector('img[loading="lazy"]');
      if (img) img.loading = 'eager';
    }
    function go(n) {
      slides[i].classList.remove('is-active'); if (thumbs[i]) thumbs[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      warm(i); warm(i + 1); warm(i - 1);
      slides[i].classList.add('is-active'); if (thumbs[i]) thumbs[i].classList.add('is-active');
      root.classList.toggle('cv-hide-badge', slides[i].hasAttribute('data-hide-badge'));
    }
    function warmAll() {
      var n = 1;
      (function next() {
        if (n >= slides.length) return;
        warm(n++);
        setTimeout(next, 150);
      })();
    }
    if (document.readyState === 'complete') warmAll();
    else window.addEventListener('load', warmAll);
    root.addEventListener('pointerenter', function () { warm(i + 1); warm(i - 1); }, { once: true });
    root.querySelectorAll('[data-prev]').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); }); });
    root.querySelectorAll('[data-next]').forEach(function (b) { b.addEventListener('click', function () { go(i + 1); }); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); x0 = null;
    });
  });

  /* Add to cart: main variant + free gifts. Drawer opens at once with a spinner, content follows. */
  var cvAddedGifts = false;
  document.querySelectorAll('[data-cv-atc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.getElementById(btn.getAttribute('data-cv-atc'));
      if (!form) return;
      if (form.tagName === 'FORM') { form.requestSubmit(); return; }
      var inCart = (form.getAttribute('data-cart-gifts') || '').split(',');
      var items = [];
      if (!cvAddedGifts) {
        (form.getAttribute('data-gifts') || '').split(',').forEach(function (v) {
          if (parseInt(v, 10) && inCart.indexOf(v) === -1) items.push({ id: parseInt(v, 10), quantity: 1, properties: { _gift: 'free' } });
        });
      }
      items.push({ id: parseInt(form.getAttribute('data-variant'), 10), quantity: 1 });
      var dest = form.getAttribute('data-after') || '/checkout';
      var drawer = dest === 'drawer' ? document.querySelector('cart-drawer') : null;
      var body = { items: items };
      if (drawer) {
        drawer.classList.add('cv-loading');
        drawer.classList.remove('is-empty');
        drawer.open(btn);
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      document.querySelectorAll('[data-cv-atc]').forEach(function (b) { b.setAttribute('disabled', 'disabled'); });
      var enable = function () { document.querySelectorAll('[data-cv-atc]').forEach(function (b) { b.removeAttribute('disabled'); }); };
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function (state) {
        cvAddedGifts = true;
        if (drawer) { drawer.renderContents(state); drawer.classList.remove('cv-loading'); enable(); }
        else if (dest === 'drawer') { window.location.href = '/cart'; }
        else { window.location.href = dest; }
      }).catch(function () {
        enable();
        if (drawer) { drawer.classList.remove('cv-loading'); drawer.close(); }
        alert(form.getAttribute('data-error') || 'Error');
      });
    });
  });

  /* Real product form (bundle app mode): keeps the app's fields, opens the drawer at once */
  document.querySelectorAll('form.cv-app-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var data = new FormData(form);
      data.append('sections', 'cart-drawer,cart-icon-bubble');
      data.append('sections_url', window.location.pathname);
      drawer.classList.add('cv-loading');
      drawer.classList.remove('is-empty');
      drawer.open(btn);
      btn.setAttribute('disabled', 'disabled');
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function (state) {
        drawer.renderContents(state); drawer.classList.remove('cv-loading'); btn.removeAttribute('disabled');
      }).catch(function () {
        btn.removeAttribute('disabled'); drawer.classList.remove('cv-loading'); drawer.close();
        alert(form.getAttribute('data-error') || 'Error');
      });
    });
  });

  /* Gifts only come with a set: a gift line without the bundle app's link to a set leaves the cart */
  function cvCheckGifts() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var updates = {}, loose = false;
      c.items.forEach(function (i) {
        if (i.product_type === 'Cadeau' && !(i.properties && i.properties.__kaching_bundles)) { updates[i.key] = 0; loose = true; }
      });
      if (!loose) return;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function () { window.location.reload(); });
    });
  }
  function cvHookGifts() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, cvCheckGifts);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cvHookGifts); else cvHookGifts();
  if (document.querySelector('.cart-count-bubble')) cvCheckGifts();

  /* Sticky ATC appears when the main button scrolls out of view */
  var mainBtn = document.querySelector('[data-cv-main-atc]');
  var sticky = document.querySelector('.cv-sticky-atc');
  if (mainBtn && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var below = e.boundingClientRect.top > window.innerHeight;
        sticky.classList.toggle('is-visible', !e.isIntersecting && !below);
      });
    }).observe(mainBtn);
  }

  /* Top price and sticky bar follow the bundle chosen in the app, including its default choice */
  var cvProduct = document.querySelector('.cv-product');
  if (cvProduct) {
    var cvCents = function (el) { return el ? parseInt(el.textContent.replace(/\D/g, ''), 10) : 0; };
    var cvSet = function (el, text) { if (el && text && el.textContent !== text) el.textContent = text; };
    var cvSyncPrice = function () {
      var bar = cvProduct.querySelector('.kaching-bundles__bar--selected');
      if (!bar) return;
      var now = bar.querySelector('.kaching-bundles__bar-price');
      var was = bar.querySelector('.kaching-bundles__bar-full-price');
      if (!now) return;
      var nowText = now.textContent.trim();
      cvSet(cvProduct.querySelector('.cv-price__now'), nowText);
      cvSet(cvProduct.querySelector('[data-cv-sticky-price]'), nowText);
      if (!was) return;
      /* The bar's struck price is rewritten to the set's total value below, so keep the regular price aside */
      var wasNow = was.textContent.trim();
      var baseText = was.getAttribute('data-cv-total') === wasNow ? was.getAttribute('data-cv-base') : wasNow;
      was.setAttribute('data-cv-base', baseText);
      /* Product line above the gifts: name, bundle price and struck-through regular price */
      var gifts = bar.querySelectorAll('.kaching-bundles__free-gift:not(.cv-kb-product)');
      var row = bar.querySelector('.cv-kb-product');
      if (!row && gifts.length) {
        row = gifts[0].cloneNode(true);
        row.classList.add('cv-kb-product');
        var link = row.querySelector('a');
        if (link) link.removeAttribute('href');
        var img = row.querySelector('img');
        var thumb = cvProduct.querySelector('.cv-gallery img');
        if (img && thumb) { img.src = thumb.currentSrc || thumb.src; img.removeAttribute('srcset'); }
        gifts[0].parentNode.insertBefore(row, gifts[0]);
        var divider = document.createElement('div');
        divider.className = 'kaching-bundles__free-gift__divider';
        gifts[0].parentNode.insertBefore(divider, gifts[0]);
      }
      if (row) {
        var title = cvProduct.querySelector('h1');
        cvSet(row.querySelector('.kaching-bundles__free-gift__text'), title ? title.textContent.trim() : '');
        var rowPrice = row.querySelector('.kaching-bundles__free-gift__full-price');
        var rowHtml = '<span class="cv-kb-now">' + nowText + '</span><s>' + baseText + '</s>';
        if (rowPrice && rowPrice.innerHTML !== rowHtml) rowPrice.innerHTML = rowHtml;
      }
      /* Bar struck price = everything in the set at its own value; top struck price = regular price */
      var base = parseInt(baseText.replace(/\D/g, ''), 10) || 0;
      var total = base;
      /* Gifts: 0,00 above their own struck-through value */
      var zero = baseText.replace(/[\d.,\s]/g, '') + '0,00';
      gifts.forEach(function (g) {
        var gp = g.querySelector('.kaching-bundles__free-gift__full-price');
        if (!gp) return;
        if (!gp.querySelector('.cv-kb-now')) {
          gp.setAttribute('data-cv-orig', gp.textContent.trim());
          gp.classList.add('cv-kb-price');
          gp.innerHTML = '<span class="cv-kb-now">' + zero + '</span><s>' + gp.getAttribute('data-cv-orig') + '</s>';
        }
        total += parseInt(gp.getAttribute('data-cv-orig').replace(/\D/g, ''), 10) || 0;
      });
      var totalText = baseText.replace(/[\d.,\s]/g, '') + (total / 100).toFixed(2).replace('.', ',');
      was.setAttribute('data-cv-total', totalText);
      cvSet(was, totalText);
      cvSet(cvProduct.querySelector('.cv-price__was'), baseText);
      var pill = cvProduct.querySelector('.cv-price .cv-pill');
      if (pill && base) cvSet(pill, pill.textContent.replace(/\d+/, Math.round((base - cvCents(now)) / base * 100)));
    };
    new MutationObserver(cvSyncPrice).observe(cvProduct, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    cvSyncPrice();
  }

  /* Long reviews fold: "Lire la suite" appears only when the text does not fit */
  function cvFoldReviews() {
    document.querySelectorAll('[data-cv-fold]').forEach(function (p) {
      if (p.nextElementSibling && p.nextElementSibling.classList.contains('cv-rcard__more')) return;
      if (p.scrollHeight <= p.clientHeight + 2) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cv-rcard__more';
      btn.textContent = 'Lire la suite';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = p.closest('.cv-rcard').classList.toggle('is-open');
        btn.textContent = open ? 'Réduire' : 'Lire la suite';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      p.parentNode.insertBefore(btn, p.nextSibling);
    });
  }
  cvFoldReviews();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(cvFoldReviews);
  window.addEventListener('load', cvFoldReviews);

  /* Email popup */
  var popup = document.querySelector('[data-cv-popup]');
  if (popup) {
    var key = 'cv_popup_seen';
    var seen = false;
    try { seen = localStorage.getItem(key) === '1'; } catch (e) {}
    var shownAfterSubmit = popup.getAttribute('data-posted') === 'true';
    function close() { popup.classList.remove('is-open'); try { localStorage.setItem(key, '1'); } catch (e) {} }
    popup.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
    popup.addEventListener('click', function (e) { if (e.target === popup) close(); });
    if (shownAfterSubmit) { popup.classList.add('is-open'); }
    else if (!seen) {
      setTimeout(function () { popup.classList.add('is-open'); }, parseInt(popup.getAttribute('data-delay') || '6', 10) * 1000);
    }
  }
})();

/* Loop videos: load and play only when scrolled into view (keeps them off the LCP critical path) */
(function () {
  var vids = document.querySelectorAll('video[data-cv-autoplay]');
  if (!vids.length) return;
  function start(v) { v.muted = true; v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) start(e.target); else if (!e.target.paused) e.target.pause();
    });
  }, { rootMargin: '200px 0px' });
  vids.forEach(function (v) { io.observe(v); });
})();
